export default __webpack_public_path__ + "static/media/Vambrace of the Sanguine Disciple (nm).6c01be7c.jpg";